module.exports = __webpack_public_path__ + "img/LoadingCasino.a6b9274b.png";